import LanguageService from './languageService'
import LanguageRepository from './languageRepository'

const languageRepository = new LanguageRepository()
export const languageService = new LanguageService(languageRepository)

export default languageService
